import {
  generateAuthToken,
  generateExternalApiKey,
  RedeemerApps,
} from '../api/auth';
import { ROOT_DOMAIN } from '../constants/brand';

/**
 * Absolute root URL of a sibling app, no trailing slash.
 *
 * The fallbacks are NOT cosmetic. `navigateToApp` assigns
 * `${getAppUrlByType(app)}/signin?...` to `window.location.href`, so an empty
 * string yields a SAME-ORIGIN path: the user silently reloads this app's own
 * /signin instead of landing in the sibling app, with no error anywhere. The
 * deployed build may not set these `REACT_APP_*_URL` vars (nothing in the
 * buildspecs does), so each case falls back to the production host, mirroring
 * how `pages/Signin/SignInFields.tsx` links to the same two apps.
 *
 * `births.` is inferred from the app's own naming (`births@provenance.co`,
 * SSO_BIRTHS_APP_ID); confirm it against DNS if the Baby Letter Builder
 * redirect 404s, since unlike notes/reflections it has no other reference in
 * the codebase.
 */
export const getAppUrlByType = (appType: RedeemerApps) => {
  switch (appType) {
    case RedeemerApps.REFLECTIONS:
      return (
        process.env.REACT_APP_REFLECTIONS_URL ||
        `https://reflections.${ROOT_DOMAIN}`
      );
    case RedeemerApps.BIRTHS:
      return process.env.REACT_APP_BIRTHS_URL || `https://births.${ROOT_DOMAIN}`;
    case RedeemerApps.THANKYOU:
      return (
        process.env.REACT_APP_THANKYOUNOTES_URL || `https://notes.${ROOT_DOMAIN}`
      );
    default:
      return '';
  }
};

export const getAppTitleByType = (appType: RedeemerApps) => {
  switch (appType) {
    case RedeemerApps.REFLECTIONS:
      return 'Community Reflections';
    case RedeemerApps.BIRTHS:
      return 'Baby Letter Builder';
    case RedeemerApps.THANKYOU:
      return 'Thank You Notes';
    default:
      return '';
  }
};

export const navigateToApp = async (
  ceremonyId: number,
  redeemerApp: RedeemerApps
) => {
  const tokenData = await generateAuthToken({
    redeemerApp: redeemerApp,
  });

  const appApiKey = await generateExternalApiKey({
    ceremonyId: ceremonyId,
    redeemerApp: redeemerApp,
  });

  //navigate to window
  window.location.href = `${getAppUrlByType(redeemerApp)}/signin?token=${
    tokenData.token
  }&externalApiKey=${appApiKey.token}&externalEventId=${ceremonyId}`;
};
